<section class="container">   
    <div *ngIf="ticketingModel">
        <div class="col-md-9">
            <div class="row section-separator">
                <ul class="list-group backgroundless-th mb-0">
                    <li class="list-group-item clearfix">
                        <div class="col-xs-10 no-padding">
                            <span class="header-font">
                                {{'customer-service.Ticket' |translate | translateKey}} - {{ticketingModel.ticketNumber}} - {{ticketingModel.subject}}
                            </span>
                        </div>
                        <div class="col-xs-2 no-padding">
                            <div class="">
                                <span  *ngIf="isTicketEditPermission" class="pull-right header-font">
                                    <i id="edit" tabindex="0" type="button" class="fa fa-pencil color-blue" aria-hidden="true" (click)="editTicket()" (keyup.enter)="editTicket()" ></i>
                                </span>
                                <span *ngIf="isTicketEditPermission" class="bars-icon">
                                    <draft-email-ticket [distributorInfo]="distributorInfo" [storeInfo]="storeInfo" [ticketingModel]="ticketingModel" [tabIndex]="tabIndex" [isTeamTicket]="isTeamTicket" [isFormTicket]="isFormTicket" [isFdTicket]="isFdTicket"></draft-email-ticket>
                                </span>
                                </div>
                        </div>
                    </li>
                    <li class="list-group-item no-padding">
                        <div class="table-responsive">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th>
                                            {{'customer-service.PRIORITY' |translate | translateKey}}
                                        </th>
                                        <th>
                                            {{'customer-service.Assigned to User' |translate | translateKey}}
                                        </th>
                                        <th>
                                            {{'customer-service.DUE DATE' |translate | translateKey}}
                                        </th>
                                        <th>
                                            {{'customer-service.STATUS' |translate | translateKey}}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td class="left-padding-1">
                                            {{ticketingModel.priorityValue}}
                                        </td>
                                        <td class="left-padding-1">
                                            {{ticketingModel.assignedToValue ? ticketingModel.assignedToValue : 'NA' }}
                                        </td>
                                        <td *ngIf="ticketingModel.dueDate" class="left-padding-1">
                                            {{ticketingModel.dueDate}}
                                        </td>
                                        <td *ngIf="!ticketingModel.dueDate" class="left-padding-1">
                                            NA
                                        </td>
                                        <td class="left-padding-1">
                                            {{ticketingModel.statusValue}}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="section-separator">
                <div class="row color-blue">
                    {{'customer-service.DESCRIPTION' |translate | translateKey}}
                </div>
                <div class="row" id="description-block">
                    <div class="description-block pre-styles word-break--overflow" *ngIf="sourceEnums.Phone === ticketingModel.sourceId"  [embedHTML]="ticketingModel.description | replaceLinks |safeHtml"> </div>
                    <span  class="viewTicketDescription"  [embedHTML]="ticketingModel.description | replaceLinks |safeHtml" *ngIf="sourceEnums.Email === ticketingModel.sourceId || sourceEnums.Online_Form === ticketingModel.sourceId"></span>
                    </div>
            </div>
            <!-- /Description end -->
            <!-- Product Line Items Block Starts -->
            <div class="row table-responsive max-width-table section-separator worktickets-table" *ngIf="isDisputeTicket && orderInfo && orderInfo.productInfo">
                <table class="product-line table table-striped custab">
                    <thead>
                        <tr>
                            <th class="width-40">{{'ticketing-system.Item#'|translate | translateKey}}</th>
                            <th class="width-400">{{'ticketing-system.Product Description'|translate | translateKey}}</th>
                            <th class="width-40">{{'ticketing-system.Qty'|translate | translateKey}}</th>
                            <th class="width-100">{{'ticketing-system.Already Disputed Qty'|translate | translateKey}}</th>
                            <th class="width-100">{{'ticketing-system.New Dispute Qty'|translate | translateKey}}</th>
                            <th class="width-170">{{'ticketing-system.Reason'|translate | translateKey}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of productDisputeInfoList">
                            <td>{{item.itemNumber}}</td>
                            <td>{{item.productDescription}}</td>
                            <td>{{item.quantity}}</td>
                            <td>{{item.alreadyDisputedQuantity}}</td>
                            <td>{{item.newDisputedQuantity}}</td>
                            <td *ngIf="item.productDisputeReason">{{item.productDisputeReason}}</td>
                            <td *ngIf="!item.productDisputeReason">NA</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <!-- Product Line Items Block Ends -->
            <!-- Time Stamp table started -->
            <div  class="note-email-tab section-separator">
                <tabset>
                    <tab heading="Notes" id="tab1">
                        <div class="row table-responsive max-width-table  worktickets-table">
                            <table class="table table-striped custab">
                                <thead>
                                    <tr>
                                        <th class="col-xs-2">
                                            <strong>{{'customer-service.Time Stamp' |translate | translateKey}}</strong>
                                        </th>
                                        <!-- <th>{{'ticketing-system.Time Stamp' |translate | translateKey}}&nbsp;</th> -->
                                        <th class="col-xs-2"><strong>{{'customer-service.Created By' | translate | translateKey}}</strong></th>
                                        <th class="cols-xs-8">{{'ticketing-system.Notes' |translate | translateKey}}</th>
                                    </tr>
                                </thead>
                                <tbody *ngIf="ticketingModel.notes?.length>0">
                                    <tr *ngFor="let note of ticketingModel.notes">
                                        <td>
                                            {{note.createdDate}}
                                        </td>
                                        <td>{{note.createdByValue}}</td>
                                        <td id="notes-content" class="textarea-format" [innerHTML]="note.value | safeHtml"></td>
                                    </tr>
                                </tbody>
                                <tbody *ngIf="ticketingModel.notes?.length===0">
                                    <tr>
                                        <td colspan="3" class="text-center">
                                            {{'customer-service.No Notes found on this ticket.' |translate |translateKey}}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </tab>
                    <tab heading="Emails">
                        <div class="row table-responsive max-width-table section-separator worktickets-table">
                        <app-ticket-email-history [ticketID] ="ticketID"></app-ticket-email-history>
                      </div>
                    </tab>
                </tabset>
            </div>
            
            <!-- Attachment table started -->           
            <div class="clearfix row section-separator">
                <div class="col-xs-12 col-md-5 no-padding">
                    <table class="table table-striped custab">
                        <thead>
                            <tr>
                                <th>{{'ticketing-system.File Name' |translate | translateKey}}&nbsp;</th>
                                <th class="text-center">{{'ticketing-system.Actions' |translate | translateKey}}&nbsp;</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of existFiles,let i=index">
                                <td>{{item.fileName}}</td>
                                <td class="options text-align-center">
                                    <i style="color: #337ab7;" class="fa text-primary fa-download pr-10" (click)="downloadDocument(item.url,item.fileName)" title="{{'documentlibrary.download '|translate | translateKey}}">
                                    </i>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="2" ><span *ngIf="existFiles.length === 0">{{'ticketing-system.No attachments found' |translate |translateKey}}.</span>  {{'ticketing-system.Max 5 attachments allowed' |translate | translateKey}}.</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="col-xs-hidden col-md-6"></div>
            </div>
            <div class="row table-responsive max-width-table section-separator worktickets-table">
                <table class="table table-striped custab">
                    <thead>
                        <tr>
                            <th class="col-xs-2 pointer">
                                <strong>{{'customer-service.Time Stamp' |translate | translateKey}}&nbsp;
                                    <i tabindex="0" (keyup.enter)="sortTableByColumn('createDate')" (click)="sortTableByColumn('createDate')" class="font-12 fa fa-sort"
                                        [ngClass]="{'fa-sort': sortColumn != 'createDate', 'fa-sort-asc': (sortColumn  == 'createDate' && !isDesc), 'fa-sort-desc': (sortColumn  == 'createDate' && isDesc) }">
                                    </i>
                                </strong>
                            </th>
                            <th class="col-xs-2 pointer">
                                <strong>{{'customer-service.User' |translate | translateKey}}&nbsp;
                                    <i tabindex="0" (keyup.enter)="sortTableByColumn('changedBy')" (click)="sortTableByColumn('changedBy')" class="font-12 fa fa-sort"
                                        [ngClass]="{'fa-sort': sortColumn != 'changedBy', 'fa-sort-asc': (sortColumn  == 'changedBy' && !isDesc), 'fa-sort-desc': (sortColumn  == 'changedBy' && isDesc) }">
                                    </i>
                                </strong>
                            </th>
                            <th class="col-xs-1 pointer">
                                <strong>{{'customer-service.Action' |translate | translateKey}}&nbsp;
                                    <i tabindex="0" (keyup.enter)="sortTableByColumn('actionType')" (click)="sortTableByColumn('actionType')" class="font-12 fa fa-sort"
                                        [ngClass]="{'fa-sort': sortColumn != 'actionType', 'fa-sort-asc': (sortColumn  == 'actionType' && !isDesc), 'fa-sort-desc': (sortColumn  == 'actionType' && isDesc) }">
                                    </i>
                                </strong>
                            </th>
                            <th class="col-xs-5">
                                <strong>{{'customer-service.Summary' |translate | translateKey}}&nbsp;
                                    <i tabindex="0">
                                    </i>
                                </strong>
                            </th>
                            <th>
                                <strong>{{'customer-service.Detail' |translate | translateKey}}&nbsp;
                                    <i tabindex="0">
                                    </i>
                                </strong>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let log of ticketActivityLogList | paginate: { itemsPerPage: 5, currentPage: p }">
                            <td>
                                {{log.createDate}}
                            </td>
                            <td>
                                {{log.changedBy}}
                            </td>
                            <td>
                                {{log.actionType}}
                            </td>
                            <td><div class="textarea-format" [embedHTML]="log.summary |safeHtml"></div>
                            </td>
                            <td>
                                <a *ngIf="log.changedData" (click)="openTicketActivityModal(log.changedData)">{{'customer-service.View Details..' |translate | translateKey}} </a>
                            </td>
                        </tr>
                    </tbody>
                    <tbody *ngIf="ticketActivityLogList?.length===0">
                        <tr>
                            <td colspan="5" class="text-center">{{'customer-service.No Activity found on this ticket.' |translate |translateKey}}</td>
                        </tr>
                    </tbody>
                </table>  
                
                <div class="pull-right">
                    <pagination-controls (pageChange)="p = $event"></pagination-controls>
                </div>             
            </div>           
        </div>
        <div *ngIf="accountRestriction">
            <account-restriction-popup [memberDetails]="memberDetails" (closeModal)="closeModal($event)"></account-restriction-popup>
        </div>
        <div class="col-md-3 col-xs-12 business-owner-block right-padding-0">
            <div>
                <ul class="list-group">
                    <li class="list-group-item  margin-0">
                        <div class="heading-section">{{'ticketing-system.FOREVER BUSINESS OWNER' |translate | translateKey}}</div>
                        <div>
                            <div class="row">
                                <div class="col-md-4">
                                    <span>{{'ticketing-system.Name' |translate | translateKey}}</span>
                                </div>
                                <div *ngIf="distributorInfo && distributorInfo.name" class="col-md-8 text-right">
                                        <a (click)="navigateToFBOProfile()">
                                    <span>{{distributorInfo.name | titleCase}}</span></a>
                                </div>
                                <div *ngIf="!distributorInfo && !fboProfileDetail" class="col-md-8 text-right">
                                    <span>N/A</span>
                                </div>
                                <div *ngIf="!distributorInfo && fboProfileDetail && fboProfileDetail.firstName" class="col-md-8 text-right">
                                        <a (click)="navigateToFBOProfile()">
                                    <span>{{fboProfileDetail | displayNameFormat}}</span></a>
                                </div>
                                <div *ngIf="!distributorInfo && fboProfileDetail && fboProfileDetail.displayName && fboProfileDetail.memberTypeId === memberTypeEnum.DISTRIBUTOR" class="bold">
                                    <span>{{fboProfileDetail.displayName | titlecase}}</span>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-5">
                                    <span>{{'ticketing-system.FBO ID' |translate | translateKey}}</span>
                                </div>
                                <div *ngIf="distributorInfo && distributorInfo.distributorId" class="col-md-7 text-right">
                                    <a *ngIf="distributorInfo.distributorId"><i  class="fa fa-copy" [copyToClipboard]="distributorInfo.distributorId"></i></a>
                                    <a (click)="navigateToFBOProfile()">
                                    <span>{{distributorInfo.distributorId |distributorIdFormat}}</span></a>
                                </div>
                                <div *ngIf="!distributorInfo && !fboProfileDetail" class="col-md-7 text-right">
                                    <span>N/A</span>
                               </div>
                                <div *ngIf="!distributorInfo && fboProfileDetail && fboProfileDetail.fboId" class="col-md-7 text-right">
                                    <a *ngIf="fboProfileDetail?.fboId"><i class="fa fa-copy"  [copyToClipboard]="fboProfileDetail?.fboId"></i></a>  
                                        <a (click)="navigateToFBOProfile()">
                                    <span>{{fboProfileDetail.fboId |distributorIdFormat}}</span></a>
                                </div>
                            </div>
                        </div>
                        <div class="heading-section pt-20">{{'ticketing-system.TICKET DETAILS' |translate | translateKey}}</div>
                        <div>
                            <div class="row">
                                <div class="col-md-6 padding-left-14">
                                    <span>{{'ticketing-system.Operating Country' |translate | translateKey}}</span>
                                </div>
                                <div class="col-md-6 text-right">
                                    <span>{{ticketingModel.operatingCountryName | titlecase}}</span>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-5">
                                    <span>{{'ticketing-system.Created By' |translate | translateKey}}</span>
                                </div>
                                <div class="col-md-7 text-right">
                                    <span>{{ticketingModel.createdByValue}}</span>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-5">
                                    <span>{{'ticketing-system.Created Date' |translate | translateKey}}</span>
                                </div>
                                <div class="col-md-7 text-right">
                                    <span>{{ticketingModel.createdDate}}</span>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-5">
                                    <span *ngIf="sourceEnums.Phone === ticketingModel.sourceId">{{'ticketing-system.Caller Name' |translate | translateKey}}</span>
                                    <span *ngIf="sourceEnums.Email === ticketingModel.sourceId || sourceEnums.Online_Form === ticketingModel.sourceId">{{'ticketing-system.Sender Name' |translate | translateKey}}</span>
                                </div>
                                <div class="col-md-7 text-right">
                                    <span>{{ticketingModel.callerName}}</span>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6 padding-left-14">
                                    <span *ngIf="sourceEnums.Phone === ticketingModel.sourceId">{{'ticketing-system.Caller Phone Number' |translate | translateKey}}</span>
                                    <span *ngIf="sourceEnums.Email === ticketingModel.sourceId || sourceEnums.Online_Form === ticketingModel.sourceId">Sender Email</span>
                                </div>
                                <div class="col-md-6 text-right">
                                    <span *ngIf="sourceEnums.Phone === ticketingModel.sourceId">{{ticketingModel.sourceIdentifierValue | mask:phoneNumberFormat}}</span>
                                    <span *ngIf="sourceEnums.Email === ticketingModel.sourceId || sourceEnums.Online_Form === ticketingModel.sourceId">{{ticketingModel.sourceIdentifierValue}}</span>
                                </div>
                            </div>

                            <div class="row">
                                    <div class="col-md-5">
                                        <span>{{'ticketing-system.Source' |translate | translateKey}}</span>
                                    </div>
                                    <div class="col-md-7 text-right">
                                        <span *ngIf="sourceEnums.Phone === ticketingModel.sourceId">
                                                {{'ticketing-system.Phone' |translate | translateKey}}
                                        </span>
                                        <span *ngIf="sourceEnums.Email === ticketingModel.sourceId">
                                                {{'ticketing-system.Email' |translate | translateKey}}
                                        </span>
                                        <span *ngIf="sourceEnums.Online_Form === ticketingModel.sourceId">
                                            {{'ticketing-system.Online Form' |translate | translateKey}}
                                        </span>
                                    </div>
                            </div>

                            <div class="row">
                                <div class="col-md-5">
                                    <span>{{'ticketing-system.Assign to Dept' |translate | translateKey}}</span>
                                </div>
                                <div class="col-md-7 text-right">
                                    <span>{{ticketingModel.departmentName}}</span>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-5">
                                    <span>{{'ticketing-system.Ticket Type' |translate | translateKey}}</span>
                                </div>
                                <div class="col-md-7 text-right">
                                    <span>{{ticketingModel.typeValue}}</span>
                                </div>
                            </div>
                            <!-- COPY TO USER LIST -->
                            <div class="row">
                                <div class="col-md-5">
                                    <span>{{'ticketing-system.CC List' |translate | translateKey}}</span>
                                </div>
                                <div class="col-md-7 text-right"  *ngIf="ticketingModel.copyToUsers">
                                    <div *ngFor="let copyToUser of ticketingModel.copyToUsers">
                                        <span>{{ copyToUser.firstName }} {{ copyToUser.lastName }}</span>
                                    </div>
                                </div>
                                <div class="col-md-7 text-right"  *ngIf="!ticketingModel.copyToUsers">
                                    <span>N/A</span>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="orderInfo">
                            <div class="heading-section pt-20">{{'ticketing-system.ORDER SUMMARY' |translate | translateKey}}</div>
                            <div>
                                <div class="row">
                                    <div class="col-md-7">
                                        <span>{{'ticketing-system.Web Order Number' |translate | translateKey}}</span>
                                    </div>
                                    <div class="col-md-5 text-right">
                                        <a (click)="navigateToOrderInfo()"><span>{{orderInfo.webOrderNumber}}</span></a>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-5">
                                        <span>{{'ticketing-system.Order Number' |translate | translateKey}}</span>
                                    </div>
                                    <div class="col-md-7 text-right">
                                        <a (click)="navigateToOrderInfo()"> <span>{{orderInfo.orderNumber}}</span></a>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-5">
                                        <span>{{'ticketing-system.Order Date' |translate | translateKey}}</span>
                                    </div>
                                    <div class="col-md-7 text-right">
                                        <span>{{orderInfo.orderDate | date:'dd-MMM-yyyy HH:mm:ss'}}</span>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6">
                                        <span>{{'ticketing-system.Warehouse Name' |translate | translateKey}}</span>
                                    </div>
                                    <div class="col-md-6 text-right">
                                        <span>{{orderInfo.shippingInfo.warehouseName}}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="heading-section pt-20">{{'ticketing-system.DELIVERY' |translate | translateKey}}</div>
                            <div>
                                <div class="row">
                                    <div class="col-md-6">
                                        <span *ngIf="!orderInfo.deliveryPreferenceId || (orderInfo.deliveryPreferenceId && orderInfo.deliveryPreferenceId !== 2)">{{'ticketing-system.Shipping Method' |translate | translateKey}}</span>
                                        <span *ngIf="orderInfo.deliveryPreferenceId && orderInfo.deliveryPreferenceId === 2">{{'ticketing-system.Pick Up' |translate | translateKey}}</span>
                                    </div>
                                    <div class="col-md-6 text-right">
                                        <span *ngIf="!orderInfo.deliveryPreferenceId || (orderInfo.deliveryPreferenceId && orderInfo.deliveryPreferenceId !== 2)">{{orderInfo.shippingInfo.shippingMethod}}</span>
                                    </div>
                                </div>
                                <div *ngIf="orderInfo &&  orderInfo.address">
                                    <div class="row">
                                        <div class="col-md-4" *ngIf="orderInfo.address.addressLine1">
                                           <span> {{'ticketing-system.Address' |translate | translateKey}}</span>
                                        </div>
                                        <div class="col-md-8 text-right" *ngIf="orderInfo.address.addressLine1">
                                            <span> {{orderInfo.address.addressLine1 | titlecase}}</span>
                                        </div>
                                       
                                    </div>
                                    <div class="row">
                                        <div class="col-md-12 text-right" *ngIf="orderInfo.address.addressLine2">
                                            <span> {{orderInfo.address.addressLine2 | titlecase}}</span>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-12 text-right" *ngIf="orderInfo.address.addressLine3">
                                            <span> {{orderInfo.address.addressLine3 | titlecase}}</span>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-12 text-right" *ngIf="orderInfo.address.addressLine4">
                                            <span> {{orderInfo.address.addressLine4 | titlecase}}</span>
                                        </div>
                                    </div>
                                    <div class="row">
                                           <div *ngIf="orderInfo.address.city" class="col-md-12 text-right">
                                            <span>{{orderInfo.address.city | titlecase}}</span>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div *ngIf="orderInfo.address.stateCode && orderInfo.address.postalCode "
                                            class="col-md-12 text-right">
                                            <span>{{orderInfo.address.stateCode | uppercase}}</span>,<span>{{orderInfo.address.postalCode | uppercase}}</span>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div *ngIf="orderInfo.address.countryCode" class="col-md-12 text-right">
                                            <span>{{orderInfo.address.countryCode | uppercase}}</span>
                                        </div>
                                    </div>
                                    
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
    </section>
    <modal #ticketActivityDetailsModal >
        <modal-header>
            <h4 class="color-blue" >{{'ticketing-system.TICKET DETAILS' |translate}}</h4>      
        </modal-header>
        <modal-content >
            <div  class="" [innerHTML]="ticketActivityChangeData | safeHtml" >
            </div>
        </modal-content>
        <modal-footer>
            <div class="pull-right">     
                <button class="btn blue-button" type="button" tabindex="0" (keyup.enter)="closeTicketActivityPopup()" (click)="closeTicketActivityPopup()">
                    {{'ticketing-system.Ok' |translate}}                                                                                              
                </button>
            </div>
        </modal-footer>
    </modal>


// WEBPACK FOOTER //
// ./src/app/customerservice/templates/template1/views/ticket-view.component.html